import axios, { isAxiosError } from 'axios';
import { useRef, useState } from 'react';
export const useOtpSetup = (baseUrl: string) => {
  const [operationPending, setOperationPending] = useState(true);

  const status = useRef<Promise<boolean> | null>(null);
  if (status.current === null) {
    status.current = new Promise((resolve) => {
      axios
        .get(baseUrl)
        .then((response) => {
          resolve(response.data.enabled);
        })
        .finally(() => setOperationPending(false));
    });
  }

  const requestKey = () => {
    setOperationPending(true);
    return axios.get(`${baseUrl}/new`).then(
      (response) => {
        setOperationPending(false);
        return response.data;
      },
      () => setOperationPending(false),
    );
  };
  const verifyCode = (code: string) => {
    setOperationPending(true);
    return axios.post(baseUrl, { otp_attempt: code }).then(
      (response) => {
        setOperationPending(false);
        return response.data;
      },
      () => setOperationPending(false),
    );
  };
  const disableOtp = (code: string) => {
    setOperationPending(true);
    return axios.delete(baseUrl, { data: { otp_attempt: code } }).then(
      (response) => {
        setOperationPending(false);
        return response;
      },
      (ex) => {
        setOperationPending(false);
        throw ex;
      },
    );
  };
  return { statusPromise: status.current, requestKey, verifyCode, disableOtp, operationPending };
};

type LoginResponse<T extends Record<string, any>> =
  | {
      success: false;
      requestOtp?: boolean;
    }
  | ({ success: true } & T);
export const otpLogin =
  <TCredentials = Record<string, any>, TResponse extends Record<string, any> = Record<string, any>>(
    url: string,
  ) =>
  async (credentials: TCredentials): Promise<LoginResponse<TResponse>> => {
    try {
      const res = await axios.post<LoginResponse<TResponse>>(url, {
        credentials,
      });
      const { success, requestOtp, ...rest } = res.data;
      if (requestOtp) {
        return { success: false, requestOtp };
      }
      if (success) {
        return { success, ...rest } as TResponse & { success: true };
      }
    } catch (ex) {
      if (isAxiosError(ex) && (ex.response?.status === 400 || ex.response?.status === 401)) {
        // swallow authentication errors
      } else {
        throw ex;
      }
    }
    return { success: false };
  };
